import axios from 'axios';
import {
  AddEmployee,
  PromoteDesignation,
  SearchEmployee,
  UpdateEmployee,
  UpdateEmployeeProfile
} from 'src/models/employee';
import { get, post, put, remove } from './mainApi';
import { string } from 'prop-types';
import { sr } from 'date-fns/locale';
import moment from 'moment';
import { generateId } from 'src/utils/traceIdGenerations';
import { DesignationResponse } from 'src/content/employeeOnboarding/candidate/types/candidate.types';
import { DesignationOption } from 'src/content/employeeOnboarding/candidate/types/candidate.types';
import { decryptResponseData } from 'src/utils/cryptoUtils';

const employeeServiceBaseURL =
  process.env.REACT_APP_EMPLOYEE_MANAGEMENT_ENDPOINT;
  
const leaveManagementServiceEndPoint =
  process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT;
const EmployeeFilterURL = process.env.REACT_APP_TIME_LOG_ENDPOINT;
const EmployeeManagementServiceURL = process.env.REACT_APP_EMPLOYEE_MANAGEMENT_SERVICE_ENDPOINT;

export const getAllEmployees = async () => {
  var response = get(employeeServiceBaseURL);
  return response;
};

export const getAllReportingManagers = async () => {
  try {
    const fetchByEmploymentType = async (employmentType: string) => {
      const traceId = generateId(9);
      const body = {
        id: null,
        name: null,
        employeeId: null,
        tier: null,
        isResign: null,
        genderId: null,
        maritalStatusId: null,
        employmentStatus: 'Active',
        employmentType,
        page: null,
        size: null
      };

      const response = await axios.post(
        `${EmployeeManagementServiceURL}employee/profiles/search?traceId=${traceId}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json'
          }
        }
      );

      const decrypted: any = await decryptResponseData(response.data?.data ?? response.data);
      return decrypted?.employees || [];
    };

    const [permanentEmployees, probationEmployees] = await Promise.all([
      fetchByEmploymentType('Permanent'),
      fetchByEmploymentType('Probation')
    ]);

    const employeesById = new Map();
    [...permanentEmployees, ...probationEmployees].forEach((employee: any) => {
      const key = employee?.employeeId || employee?.id;
      if (key && !employeesById.has(String(key))) {
        employeesById.set(String(key), employee);
      }
    });

    return { data: { employees: Array.from(employeesById.values()) } };
  } catch (error) {
    console.error('Error fetching reporting managers:', error);
    throw error;
  }
};

export const getAllEmployeeNameList = async () => {
  var response = get(`${employeeServiceBaseURL}basic-information`);
  return response;
};

export const getReporterByEmpId = async (empId) => {
  var response = get(`${employeeServiceBaseURL}reporter/${empId}`);
  return response;
};

export const getEmployeeFile = async (fileId) => {
  var response = get(`${employeeServiceBaseURL}attachment/document?` + fileId);
  return response;
};

export const getLatestInternId = async () => {
  var response = get(`${employeeServiceBaseURL}latest-intern-id`);
  return response;
};
export const downloadEmployeeReport = async () => {
  var response = get(`${employeeServiceBaseURL}report`, 'blob');
  return response;
};

export const getAllBanks = async () => {
  var response = get(`${employeeServiceBaseURL}bank/all`);
  return response;
};

export const addBank = async (data: any) => {
  var response = post(`${employeeServiceBaseURL}bank`, data);
  return response;
};

export const updateBank = async (data) => {
  const response = put(`${employeeServiceBaseURL}bank`, data);
  return response;
};

export const deleteBank = async (name: any) => {
  var response = remove(`${employeeServiceBaseURL}bank/${name}`);
  return response;
};

export const getAllSkills = async () => {
  var response = get(`${employeeServiceBaseURL}skill-value/all`);
  return response;
};

export const addNewSkill = async (data: any) => {
  var response = post(`${employeeServiceBaseURL}skill-values`, data);
  return response;
};

export const addSkillsUser = async (skills: any) => {
  const promises: any = [];
  skills.forEach((skill) => {
    promises.push(post(employeeServiceBaseURL + 'skills', skill));
  });
  await Promise.all(promises);
};

export const getSkillsUser = async (id: any) => {
  var response = get(`${employeeServiceBaseURL}skill?employeeId=${id}`);
  return response;
};

export const deleteSkillsUser = async (data: any) => {
  var response = remove(`${employeeServiceBaseURL}skills`, data);
  return response;
};

export const addEmployee = async (
  employeInformation: AddEmployee,
  setTableId?: any
) => {
  var response = await post(employeeServiceBaseURL, employeInformation);

  if (response && setTableId) {
    setTableId(employeInformation.employeeId);
  }
  return response;
};

export const getEmployeeList = async (data: SearchEmployee) => {
  const traceId = generateId(9);
  try {
    const response = await post(
      `${EmployeeManagementServiceURL}employee/profiles/search?traceId=${traceId}`,
      data
    );
    return decryptResponseData(response.data);
  } catch (error) {
    console.error('Error fetching employee list:', error);
    return null;
  }
};

export const searchEmployee = async (data: any) => {
  var response = post(employeeServiceBaseURL + 'filters', data);
  return response;
};

export const getEmployeeById = async (empId) => {
  const traceId = generateId(9);
  try {
    const response = await get(
      `${EmployeeManagementServiceURL}employee/${empId}?traceId=${traceId}`
    );
    return decryptResponseData(response.data);
  } catch (error) {
    console.error('Error fetching employee by ID:', error);
    return null;
  }
};

export const uploadEmployeeImagesById = async (
  id,
  images,
  getEmplyeeDetails?: any
) => {
  const promises: any = [];
  images.forEach((image) => {
    promises.push(
      axios.post(
        `${employeeServiceBaseURL}attachment/images`,
        {
          EmployeeId: id,
          Files: image
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    );
  });
  await Promise.all(promises);
  if (getEmplyeeDetails) getEmplyeeDetails();
};

export const uploadEmployeeImageById = async (
  id,
  image,
  getEmplyeeDetails?: any
) => {
  const res = axios.post(
    `${employeeServiceBaseURL}attachment/images`,
    {
      EmployeeId: id,
      Files: image
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  if (getEmplyeeDetails) getEmplyeeDetails();
  return res;
};

export const importEmployeeByExcel = async (doc) => {
  const res = axios.post(
    `${employeeServiceBaseURL}import`,
    {
      ImportedFile: doc
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  return res;
};

export const importEmployeeBankingByExcel = async (doc) => {
  const res = axios.post(
    `${employeeServiceBaseURL}bank/import`,
    {
      ImportedFile: doc
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return res;
};

export const getBankingTemplate = async () => {
  var response = get(`${employeeServiceBaseURL}bank/import-template`);
  return response;
};

export const uploadEmployeeDocsById = async (
  id,
  doc,
  getEmplyeeDetails?: any
) => {
  axios.post(
    `${employeeServiceBaseURL}attachment/document`,
    {
      EmployeeId: id,
      File: doc
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  if (getEmplyeeDetails) getEmplyeeDetails();
};

export const deleteEmployeeImagesById = async (imgId) => {
  var response = remove(`${employeeServiceBaseURL}attachment/images/${imgId}`);
  return response;
};

export const employeeResignation = async (data) => {
  try {
    var response = remove(employeeServiceBaseURL + 'resign-employee', data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteEmployeeDocumentsById = async (docId) => {
  var response = remove(
    `${employeeServiceBaseURL}attachment/documents/${docId}`
  );
  return response;
};

export const getEmployeeImagesById = async (empId) => {
  var response = get(`${employeeServiceBaseURL}attachment/images/${empId}`);
  return response;
};

export const getEmployeeDocsById = async (empId) => {
  var response = get(`${employeeServiceBaseURL}attachment/documents/${empId}`);
  return response;
};

export const getEmployeeDesignationHistory = async (empId) => {
  var response = get(employeeServiceBaseURL + 'designation/' + empId);
  return response;
};

export const getEmployeeManagers = async (empId) => {
  try {
    var response = get(employeeServiceBaseURL + 'reporter/' + empId);
    return response;
  } catch (error) {}
};

export const getAllTracks = async () => {
  var response = get(employeeServiceBaseURL + 'tracks');
  return response;
};

export const getAllBillingRoles = async () => {
  var response = get(employeeServiceBaseURL + 'billing-roles');
  return response;
};

export const getAllEmployeeList = async () => {
  var response = get(employeeServiceBaseURL + 'report');

  return response;
};

export const updateDesignation = async (
  designationInformation: PromoteDesignation
) => {
  var response = post(
    employeeServiceBaseURL + 'promote-designation',
    designationInformation
  );
  return response;
};

export const addManagers = async (managers: any) => {
  const promises: any = [];
  managers.forEach((manager) => {
    promises.push(post(employeeServiceBaseURL + 'reporter', manager));
  });
  await Promise.all(promises);
};

export const deleteManagers = async (additional: any) => {
  const response = remove(employeeServiceBaseURL + 'reporter', additional);
  return response;
};

export const updateEmployeeInformation = async (
  employeeInformation: UpdateEmployee,
  settableId?: any
) => {
  var response = put(employeeServiceBaseURL, employeeInformation);
  if (settableId) settableId(employeeInformation.employeeId);
  return response;
};

export const updateEmployeeInformationProfile = async (
  employeeInformation: UpdateEmployeeProfile,
  settableId?: any
) => {
  var response = put(`${employeeServiceBaseURL}profile`, employeeInformation);
  if (settableId) settableId(employeeInformation.employeeId);
  return response;
};

export const getProjectLead = async () => {
  var response = get(`${employeeServiceBaseURL}jira-lead-employee`);
  return response;
};

export const getResignationInformation = async (employeeId: string) => {
  var response = get(
    `${employeeServiceBaseURL}resignation-information?employeeId=${employeeId}`
  );
  return response;
};

export const getAllGenders = async () => {
  var response = get(`${employeeServiceBaseURL}gender`);
  return response;
};

export const addGender = async (data: any) => {
  var response = post(`${employeeServiceBaseURL}gender`, data);
  return response;
};

export const updateGender = async (data) => {
  const response = put(`${employeeServiceBaseURL}gender`, data);
  return response;
};

export const deleteGender = async (id: any) => {
  var response = remove(`${employeeServiceBaseURL}gender/?id=${id}`);
  return response;
};

export const getAllMartialStatus = async () => {
  var response = get(`${employeeServiceBaseURL}martial-status`);
  return response;
};

export const addMartialStatus = async (data: any) => {
  var response = post(`${employeeServiceBaseURL}martial-status`, data);
  return response;
};

export const updateMartialStatus = async (data) => {
  const response = put(`${employeeServiceBaseURL}martial-status`, data);
  return response;
};

export const deleteMartialStatus = async (id: any) => {
  var response = remove(`${employeeServiceBaseURL}martial-status/?id=${id}`);
  return response;
};

export const getJiraLeadEmployees = async () => {
  const response = get(`${employeeServiceBaseURL}jira-lead-employee`);
  return response;
};

export const getEmployeeExamResult = async (
  id: string,
  pageSize: number,
  pageNo: number
) => {
  let response = get(
    `${leaveManagementServiceEndPoint}academic-results/search/${id}?pageSize=${pageSize}&pageNo=${pageNo}`
  );
  return response;
};

export const getAllEmployeesFilter = async (
  customerIds: string[],
  projectIds: string[],
  startDate?: string,
  endDate?: string
) => {
  const requestBody = {
    customerIds: customerIds,
    projectIds: projectIds,
    startDate: startDate || null,
    endDate: endDate || null
  };

  const traceId = generateId(9);

  try {
    const response = await axios.post(
      `${EmployeeFilterURL}time-entry/get_filtered_employee_details?traceId=${traceId}`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDesignationOptions = async (): Promise<DesignationOption[]> => {
  try {
    const traceId = generateId(9);
    const response = await axios.get(
      `${leaveManagementServiceEndPoint}employee/designation/options?traceId=${traceId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json'
        }
      }
    );

    const result: DesignationResponse = response.data;
    return result.data || [];
  } catch (error) {
    return [];
  }
};

export const getReportingManagers = async () => {
  try {
    const res = await getAllReportingManagers();
    const decrypted: any = await decryptResponseData(res.data);
    const employees = decrypted?.employees || [];

    return employees.map((manager: any) => {
      const managerId = manager.employeeId || manager.id;
      return {
        label: manager.name,
        value: managerId,
        name: manager.name,
        id: managerId,
        employeeId: managerId
      };
    });
  } catch (error) {
    return [];
  }
};

export const getNextEmployeeId = async () => {
  const url = `${employeeServiceBaseURL}next-employee-id`;
  return await get(url);
};


export const getDocumentAcknowledgements = async (employeeId: string) => {
  try {
    const traceId = generateId(9);
    const response = await get(`${EmployeeManagementServiceURL}document_acknowledgement?traceId=${traceId}&employeeId=${employeeId}`);
    return response;
  } catch (error) {
    console.error('Failed to fetch document acknowledgements:', error);
    throw error;
  }
};

export const updateDocumentAcknowledgements = async (employeeId: string, payload: any) => {
  try {
    const traceId = generateId(9);
    const response = await axios.patch(
      `${EmployeeManagementServiceURL}document_acknowledgement/update?traceId=${traceId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Failed to update document acknowledgements:', error);
    throw error;
  }
};

export const updateDocumentAcknowledgementStatus = async (employeeId: string, status: string) => {
  try {
    const traceId = generateId(9);
    const response = await axios.patch(
      `${EmployeeManagementServiceURL}document_acknowledgement/update_status?traceId=${traceId}`,
      {
        employeeId: employeeId,
        document_acknowledgement_status: status
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Failed to update document acknowledgement status:', error);
    throw error;
  }
};

export const getAllDepartments = async (limit?: number, offset?: number) => {
  try {
    const traceId = generateId(9);
    const params = new URLSearchParams();
    params.append('traceId', traceId);
    if (limit) params.append('limit', limit.toString());
    if (offset) params.append('offset', offset.toString());
    
    const response = await axios.get(
      `${EmployeeManagementServiceURL}department/?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }
};


